import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import { noop } from 'lodash';
import { MoveItemIcon } from 'framework/ui/mui-builder';
import type { ListTableAction } from 'framework/ui/ui-builder';
import type { ApplicationRow, Stage } from '../shared/types';

type ApplicationRowAction = ListTableAction<ApplicationRow>;

const activeStages: Stage[] = ['Applied', 'Evaluating', 'Qualified', 'Offer'];
const closableStages: Stage[] = ['Rejected', 'Withdrawn'];

const isActive = (row: ApplicationRow) => activeStages.includes(row.stage);

export const applicationRowActions: ApplicationRowAction[] = [
  {
    id: 'reject-application',
    label: 'Reject application',
    tooltip: 'Reject application',
    icon: <BlockOutlinedIcon />,
    variant: 'outlined',
    color: 'error',
    isVisible: isActive,
    onClick: noop,
  },
  {
    id: 'edit-application',
    label: 'Edit application',
    tooltip: 'Edit application',
    icon: <EditOutlinedIcon />,
    variant: 'outlined',
    isVisible: isActive,
    onClick: noop,
  },
  {
    id: 'move-application',
    label: 'Move application',
    tooltip: 'Move application',
    icon: <MoveItemIcon />,
    variant: 'outlined',
    isVisible: isActive,
    onClick: noop,
  },
  {
    id: 'close-application',
    label: 'Close application',
    tooltip: 'Close application',
    icon: <CloseOutlinedIcon />,
    variant: 'outlined',
    color: 'error',
    isVisible: row => closableStages.includes(row.stage),
    onClick: noop,
  },
];

export const applicationMenuActions: ApplicationRowAction[] = [
  {
    id: 'make-decision-on-candidate',
    label: 'Make decision on candidate',
    icon: <HowToRegOutlinedIcon />,
    isVisible: isActive,
    onClick: noop,
  },
];
